import HomeBannerHeader from '@/modules/home/banner-header.home';
import { BannerHeaderCreate } from '@/modules/home/banner-header-create.home';
import { useQuery } from '@/hooks/query.hook';
import { PermissionMode } from '@/enums/mode.enum';

export default function BannerHeader() {
  const { mode } = useQuery();

  if (mode === PermissionMode.CREATE || mode === PermissionMode.EDIT) {
    return <BannerHeaderCreate />;
  }
  return <HomeBannerHeader />;
}
